import { useEffect, useRef, useState } from "react"
import styles from './tab-list.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"

interface Tab {
  id: string;
  name: string;
}

const DEFAULT_SCROLL_AMOUNT = 500

export const TabList = ({ className, scrollable, scrollAmount, elements, onSelectTab, selectedTab, availableFilters, ef, sizeFilter, setSizeFilter } : {
    elements?: Tab[]
    className?: string
    scrollable?: boolean
    onSelectTab: (idx: number)=> void
    selectedTab: number
    scrollAmount?: number,
    availableFilters?: any[], 
    ef?: any[], 
    sizeFilter: string, 
    setSizeFilter: (value: string) => void 
}) => {

    const tabsRef = useRef<HTMLUListElement>(null);
    const [showLeftButton, setShowLeftButton] = useState(false);
    const [showRightButton, setShowRightButton] = useState(false);

    const handleScroll = () => {
        if (tabsRef.current) {
          setShowLeftButton(tabsRef.current.scrollLeft > 0);
          setShowRightButton(tabsRef.current.scrollLeft < tabsRef.current.scrollWidth - tabsRef.current.offsetWidth);
        }
      };

    useEffect(() => {
        if (tabsRef.current) {
          tabsRef.current.addEventListener('scroll', handleScroll);
          handleScroll();
        }
    
        return () => {
          if (tabsRef.current) {
            tabsRef.current.removeEventListener('scroll', handleScroll);
          }
        };
      }, []);

    const handleTabClick = (index: number) => {
        onSelectTab(index);
        if (tabsRef.current && scrollable) {
          const tabElement = tabsRef.current.children[index] as HTMLElement;
          const containerWidth = tabsRef.current.offsetWidth;
          const containerScrollLeft = tabsRef.current.scrollLeft;
          const tabLeftOffset = tabElement.offsetLeft;
          const tabRightOffset = tabElement.offsetLeft + tabElement.offsetWidth;
    
          if (tabLeftOffset < containerScrollLeft) {
            tabsRef.current.scrollLeft = tabLeftOffset;
          } else if (tabRightOffset > containerScrollLeft + containerWidth) {
            tabsRef.current.scrollLeft = tabRightOffset - containerWidth;
          }
        }
      };

    const scrollLeft = () => {
        if (tabsRef.current) {
        tabsRef.current.scrollLeft -= scrollAmount ?? DEFAULT_SCROLL_AMOUNT;
        }
    };

    const scrollRight = () => {
        if (tabsRef.current) {
        tabsRef.current.scrollLeft += scrollAmount ?? DEFAULT_SCROLL_AMOUNT;
        }
    };

    return (
        <div className={styles.tabsContainer}>
           {showLeftButton && scrollable &&
            <button className={`${styles.scrollButton} ${styles.left}`} onClick={scrollLeft}>
                <FontAwesomeIcon icon={faChevronLeft}/> 
            </button>}
           <ul className={styles.tabs} ref={tabsRef}>
            {
                (elements ?? []).map((element, idx) => {
                    return (
                       element && <li key={element.id} className={`${styles.tab} ${selectedTab===idx ? styles.selectedTab : styles.regularTab}`} role="tab">
                            <button type="button" onClick={() => handleTabClick(idx)}>{element.name}</button>
                            {selectedTab === idx && availableFilters && availableFilters?.length > 1 && ef && ef?.length > 1 && (
                                <div className={styles.selectDropdown}>
                                    <select value={sizeFilter} onChange={(e) => setSizeFilter(e.target.value)}>
                                        {ef.map(filter => (
                                            <option key={filter.id} value={filter.id}>
                                                {filter.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </li>
                    );    
                })
            
            }
            </ul>
            {showRightButton && scrollable &&
                <button className={`${styles.scrollButton} ${styles.right}`} onClick={scrollRight}>
                    <FontAwesomeIcon icon={faChevronRight}/>
                </button>}
            </div>
    )

}